<!--
 * @Date: 2019-09-06 14:15:39
 * @LastEditors: Qzx
 * @LastEditTime: 2020-03-24 14:11:53
 -->
<template>
  <div class="xes-login" :class="{ inline: type == 'inline' }">
    <div class="xes-login-title" v-if="type == 'popup'">
      <i @click="close"></i>
      <div class="xes-login-logo" v-if="hasLogo"></div>
      <slot></slot>
    </div>
    <div class="xes-login-form">
      <div class="xes-login-section">
        <div class="xes-login-phone">
          <select-phone-code
            class="xes-login-code"
            v-model="currentPhoneCode"
            :options="phoneCodeList"
          ></select-phone-code>
          <input
            ref="phone"
            :class="[{ 'xes-login-input__err': phoneErr.length > 0 }, 'xes-login-input']"
            type="tel"
            name="phone"
            :maxlength="currentPhoneCode === 86 ? 11 : 8"
            placeholder="请输入手机号"
            v-model="phone"
          />
          <!-- <div class="xes-login-del" v-if="phoneClear" v-show="phoneDelShow" @click="phoneDel"></div> -->
        </div>
        <p class="xes-login__error">{{ phoneErr }}</p>
      </div>
      <div class="xes-login-section">
        <div class="xes-login-cell">
          <input
            ref="code"
            :class="[{ 'xes-login-input__err': codeErr.length > 0 }, 'xes-login-input']"
            type="tel"
            name="code"
            maxlength="6"
            placeholder="请输入验证码"
            v-model="code"
          />
          <div
            class="xes-login-btn xes-login-codeBtn"
            :class="{ disabled: codeDisabled }"
            @click="sendVCode"
          >
            {{ codeMsg }}
          </div>
        </div>
        <p class="xes-login__error">{{ codeErr }}</p>
      </div>
      <div class="xes-login-submit">
        <div class="xes-login-btn" @click="formSubmit">{{ btnMsg }}</div>
        <p class="xes-login-agreement" v-if="!isLogin">
          <i>点击确定即表示您同意</i>
          <a href="https://zt.xueersi.com/registration_agreement.html" target="_blank"
            >《用户协议与隐私条款》</a
          >
        </p>
      </div>
    </div>
    <!-- 安全验证弹窗 -->
    <van-popup
      class="xes-login-popup"
      v-model="slideShow"
      get-container="body"
      :lazy-render="false"
    >
      <slider-confirm ref="sliderConfirm" />
    </van-popup>
  </div>
</template>
<script>
import { Toast, Popup } from 'vant'
import SliderConfirm from './SlideConfirm'
import SelectPhoneCode from './components/selectPhoneCode'
export default {
  name: 'xes-tal-login',
  components: {
    'van-popup': Popup,
    SliderConfirm,
    SelectPhoneCode
  },
  props: {
    type: {
      type: String,
      default: 'popup'
    },
    phoneClear: {
      type: Boolean,
      default: true
    },
    hasLogo: {
      type: Boolean,
      default: true
    },
    autoSend: {
      type: Boolean,
      default: false
    },
    loginData: Object, // 登录新增参数
    btnMsg: {
      type: String,
      default: '确定'
    },
    device: {
      type:Number, //  设备识别   1:web   3:touch  gettoken接口需要
      default:3
    }
  },
  data() {
    return {
      isLogin: true, // 默认登录状态
      codeDisabled: true, // code btn默认置灰状态
      phone: '', // 用户手机号
      code: '', // 手机验证码
      phoneErr: '', // 手机号校验信息
      codeErr: '', // 验证码校验信息
      codeMsg: '获取验证码', // code 按钮文字
      codeTime: 59, // 倒计时的时间
      slideShow: false, // 滑块弹框的显示和隐藏
      phoneCodeList: [
        { id: 0, text: '中国', value: 86},
        { id: 1, text: '中国香港', value: 852 }
      ],
      currentPhoneCode: 86
    }
  },
  watch: {
    phone: function(val) {
      this.phoneErr = ''
      if (val.length === 11 || val.length === 8) {
        let _phoneState = this.checkPhone()
        if (_phoneState) {
          this.isLogin = true
          this.codeDisabled = false
          if (this.autoSend) {
            this.sendVCode()
          }
        }
      }
    },
    code: function(val) {
      this.codeErr = ''
    },
    currentPhoneCode() {
      this.phone = ''
    }
  },
  methods: {
    // 关闭弹框
    close() {
      this.$emit('close')
    },
    // 手机号验证
    checkPhone() {
      let _phoneReg = new RegExp('^[1][3-9][0-9]{9}$|^[5689][0-9]{7}$')
      if (!this.phone) {
        this.phoneErr = '手机号不能为空'
        this.$refs['phone'].focus()
        return false
      }
      if (!_phoneReg.test(this.phone)) {
        this.phoneErr = '请输入正确格式的手机号'
        this.$refs['phone'].focus()
        return false
      }
      return true
    },
    // 短信验证码验证
    checkCode() {
      let _codeReg = /^[0-9]{6}$/
      if (!this.code) {
        this.codeErr = '验证码不能为空'
        this.$refs['code'].focus()
        return false
      }
      if (!_codeReg.test(this.code)) {
        this.codeErr = '请输入正确的验证码'
        this.$refs['code'].focus()
        return false
      }
      return true
    },
    sendVCode() {
      if (this.codeDisabled) {
        return
      }
      let _phoneState = this.checkPhone()
      if (!_phoneState) {
        return
      }

      this.countDown() // 60秒倒计时
      this.sendPhoneCode() // 发送登录短信验证码
    },
    // 60秒倒计时模块
    countDown() {
      let codeTime = this.codeTime
      this.codeDisabled = true
      this.codeMsg = codeTime + '秒'

      this.timer = setInterval(() => {
        codeTime--
        this.codeMsg = codeTime + '秒'
        if (codeTime <= 0) {
          this.codeMsg = '重新获取'
          this.codeDisabled = false
          clearInterval(this.timer)
        }
      }, 1000)
    },
    // 发送手机验证码
    sendPhoneCode() {
      let codeParams = {
        data: {
          verify_type: 1,
          phone_code: this.currentPhoneCode,
          phone: this.phone
        },
        success: res => {
          if (res.errcode === 0) {
            this.isLogin = res.data.is_exist === 1 // 是否是新注册用户
            this.slideShow = false // 关闭 滑动验证弹
            Toast('短信已发送，请注意查收') // 成功发送短信验证码
            this.$refs['code'].focus()
            this.$emit('sendVCode', { phone: this.phone })
          } else if (res.errcode === 11021) {
            this.slideShow = true // 打开 滑动验证弹
            this.scrollTop = 0
            this.$xesTalLogin.showSlide({
              slideCallback: 'sendSMSCodeLogin',
              slideParams: codeParams,
              failCallback: err => {
                console.log(err)
              }
            })
          } else {
            Toast(res.errmsg)
            this.slideShow = false // 关闭 滑动验证弹
          }
        },
        fail: err => {
          Toast('网络异常，请检查网络')
        }
      }

      this.$xesTalLogin.sendCode(codeParams)
    },
    // 点击确定按钮
    formSubmit() {
      let _phoneState = this.checkPhone()
      if (!_phoneState) {
        return
      }

      let _codeState = this.checkCode()
      if (!_codeState) {
        return
      }

      // 参数处理
      let data = {
        phone: this.phone, // 地区不同手机号码规则不同
        phone_code: this.currentPhoneCode, // 手机地区码
        sms_code: this.code // 短信验证码
      }
      Object.assign(data, this.loginData)

      // 用户登录注册
      this.login(data)
    },
    // 用户登录注册
    login(data) {
      Toast.loading({
        message: '请求中...',
        duration: 0
      })

      let loginSmsParmas = {
        data,
        success: res => {
          if (res.errcode === 0) {
            this.slideShow = false // 关闭 滑动验证弹
            this.getToken({
              ...data,
              device:this.device,
              code: res.data.code
            })
          } else if (res.errcode === 11021) {
            Toast.clear()
            this.slideShow = true // 打开 滑动验证弹
            this.$xesTalLogin.showSlide({
              slideCallback: 'loginSms',
              slideParams: loginSmsParmas,
              failCallback: err => {
                console.log(err)
              }
            })
          } else {
            this.slideShow = false // 关闭 滑动验证弹
            Toast(res.errmsg)
          }
        },
        fail: err => {
          console.log(err)
        }
      }
      this.$xesTalLogin.login(loginSmsParmas)
    },
    // 获取临时登录token
    getToken(params) {
      this.$xesTalLogin.getToken(params).then(res => {
        if (res.stat === 1) {
          Toast.clear()
          if (res.data.code_type === 1) {
            this.$emit('loginSuccess', {
              ...res.data,
              phone: this.phone
            })
          } else {
            this.$emit('regSuccess', {
              ...res.data,
              phone: this.phone
            })
          }
        } else {
          Toast(res.data)
        }
      })
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>
<style lang="less" scoped>
.xes-login {
  width: 80vw;
  padding: 20px 20px 40px;

  .van-button--disabled {
    opacity: 0.5;
  }

  &-popup {
    border-radius: 8px;
  }

  &-banner {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 160px;

    img {
      width: 150px;
    }
  }

  &-section {
    position: relative;
  }

  &-cell {
    display: flex;
    justify-content: space-between;

    .xes-login-input {
      height: 44px;
      font-size: 16px;
      width: 120px;
      margin-right: 5px;
      padding: 0 10px;
      border: 1px solid #dcdcdc;
      border-radius: 5px;
    }

    .xes-login-btn {
      width: 134px;
      height: 44px;
      padding: 0 10px;
      line-height: 44px;

      &.disabled {
        opacity: 0.5;
      }
    }
  }

  &-input {
    &__err {
      border-color: #f13232;
    }
  }

  &-phone {
    display: flex;
    justify-content: space-between;
    height: 44px;
    font-size: 16px;
    border: 1px solid #dcdcdc;
    padding: 2px 2px 2px 0;
    line-height: 39px;
    border-radius: 5px;
    overflow: hidden;
    .xes-login-input {
      width: 100%;
    }
  }
  input:-internal-autofill-previewed,
  input:-internal-autofill-selected {
    -webkit-text-fill-color: #333333;
    transition: background-color 5000s ease-out 0.5s;
  }
  &-del {
    position: absolute;
    top: 12px;
    right: 18px;
    z-index: 99;
    width: 20px;
    height: 20px;
    background: url('./images/icon-del.png') no-repeat center;
    background-size: 100%;
  }

  &__error {
    height: 20px;
    padding-left: 10px;
    font-size: 10px;
    color: #f13232;
  }

  &-select {
    position: relative;
    z-index: 999;

    &::after {
      content: '';
      position: absolute;
      top: 18px;
      right: 18px;
      width: 0;
      height: 0;
      overflow: hidden;
      border-width: 8px;
      font-size: 0;
      line-height: 0;
      border-style: dashed dashed solid dashed;
      border-color: transparent transparent #f13232 transparent;
      border-top: none;
      transition: transform 0.5s ease;
    }

    &.active::after {
      transform: rotate(180deg);
      transition: transform 0.5s ease;
    }

    &__title {
      position: absolute;
      top: 0;
      z-index: 9999;
      width: 100%;
      height: 36px;
    }

    &__box {
      width: 100%;
      border: 1px solid #dcdcdc;
      border-top: none;
    }
  }

  &-btn {
    width: 100%;
    height: 44px;
    margin: 0 auto;
    font-size: 16px;
    font-weight: bold;
    line-height: 44px;
    text-align: center;
    color: #fff;
    background-image: linear-gradient(-91deg, #f0773c 0%, #f13232 50%);
    border: none;
    border-radius: 4px;
  }

  &-agreement {
    padding-top: 15px;
    font-size: 10px;
    line-height: 26px;
    text-align: center;
    color: #999;

    a {
      font-size: 10px;
      font-weight: bold;
      color: #999;
    }
  }
  // LoginPopup 新增
  &-title {
    display: flex;
    flex-direction: column;

    i {
      align-self: flex-end;
      width: 14px;
      height: 14px;
      margin-right: -10px;
      background: url('./images/icon-close.png') no-repeat;
      background-size: 100%;
    }

    img {
      width: 140px;
    }
  }
  // 网校 logo
  &-logo {
    width: 140px;
    height: 42px;
    margin: 0 auto 20px;
    background: url('./images/newlogo.png') no-repeat;
    background-size: 100%;
  }

  &-codeBtn {
    width: 100px;
    height: 44px;
    padding: 0 10px;
    line-height: 44px;
  }

  &-picker {
    position: absolute;
    top: 55px;
    left: 10%;
    width: 90%;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);

    &__box {
      overflow: hidden;
      border-radius: 5px;
    }

    &__arrow {
      position: relative;
      top: -8px;
      left: 25px;
    }

    &__arrow::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      z-index: 999;
      width: 0;
      height: 0;
      overflow: hidden;
      border-width: 8px;
      font-size: 0;
      line-height: 0;
      border-style: dashed dashed solid dashed;
      border-color: transparent transparent #eee transparent;
      border-top: none;
    }

    &__arrow::after {
      content: '';
      position: absolute;
      top: 2px;
      left: 2px;
      z-index: 999;
      width: 0;
      height: 0;
      overflow: hidden;
      border-width: 6px;
      font-size: 0;
      line-height: 0;
      border-style: dashed dashed solid dashed;
      border-color: transparent transparent #fff transparent;
      border-top: none;
    }
  }

  &-submit {
    margin-top: 5px;
  }

  // 内嵌样式
  &.inline {
    width: 100%;
    padding: 12px 0;
    background-color: #fff;
    .xes-login-phone {
      border: 1px solid #eee;
      border-radius: 22px;
      .xes-login-code {
        padding-left: 7px;
      }
      .xes-login-input {
        width: 200px;
      }
    }
    .xes-login-btn {
      width: 100%;
      background: linear-gradient(90deg, #ed3b31, #ff392e);
      border-radius: 22px;
      box-shadow: 0 4px 10px 0 rgba(237, 59, 49, 0.2);
    }

    .xes-login-codeBtn {
      width: 139px;
      height: 42px;
      border-radius: 22px;
    }

    .xes-login-cell {
      .xes-login-input {
        flex: 1;
        margin-right: 10px;
        padding-left: 17px;
        font-size: 13px;
        border: 1px solid #eee;
        border-radius: 22px;
      }
    }
  }
}
</style>
